import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios'

export const GetCargoCompanies = createAsyncThunk('/GetCargoCompanies', async () => {
    const response = await baseAxios.get(`/WorkOrderCargo/GetCargoCompanies`);
    return response.data;
})

export const GetWorkOrderCargo = createAsyncThunk('/GetWorkOrderCargo', async ({ workOrderId }) => {
    const params = new URLSearchParams([
        ['workOrderId', workOrderId]])
    const response = await baseAxios.get(`/WorkOrderCargo/GetWorkOrderCargo`, { params });
    return response.data;
})

export const SetWorkOrderCargo = createAsyncThunk('SetWorkOrderCargo', async dto => {
    const response = await baseAxios.post(`/WorkOrderCargo/SetWorkOrderCargo`, dto);
    return response.data;
})

export const GetWorkOrderCargoReport = createAsyncThunk('/GetWorkOrderCargoReport', async({dispatchDate}) => {
    const params = new URLSearchParams([
        ['dispatchDate', dispatchDate]])
    const response = await baseAxios.get(`/WorkOrderCargo/GetWorkOrderCargoReport`, { params });
    return response.data;
})

export const UploadCargoReport = createAsyncThunk('UploadCargoReport', async dtoList => {
    const response = await baseAxios.post(`/WorkOrderCargo/UploadCargoReport`, dtoList);
    return response.data;
})

const workOrderCargoSlice = createSlice({
    name: 'workOrderCargo',
    initialState: {
        cargoCompanies: [],
        workOrderCargo: null,
        selectedCargoCompany: null,
        selectedCargoNo: '',
        setWorkOrderCargoResponse: null,
        selectedDispatchDate: null,
        initialCargoReportData: [],
        cargoReportData: [],
        cargoReportSearched: null,
        cargoUploadRequest: [],
        selectedReturnCargoNo: '',
        selectedOutDispatchDate: null,
        selectedOutCargoCompany: null
    },
    reducers: {

        setSearched: (state, action) => {
            state.searched = action.payload
        },
        setSelectedCargoCompany: (state, action) => {
            state.selectedCargoCompany = action.payload
        },
        setselectedCargoNo: (state, action) => {
            state.selectedCargoNo = action.payload
        },
        setSelectedDispatchDate: (state, action) => {
            state.selectedDispatchDate = action.payload
        },
        setCargoReportData: (state, action) => {
            state.cargoReportData = action.payload
        },
        setCargoReportSearched: (state,action) => {
            state.cargoReportSearched = action.payload
        },
        setSelectedReturnCargoNo: (state, action) => {
            state.selectedReturnCargoNo = action.payload;
        },
        setSelectedOutDispatchDate: (state, action) => {
            state.selectedOutDispatchDate = action.payload;
        },
        setSelectedOutCargoCompany: (state, action) => {
            state.selectedOutCargoCompany = action.payload;
        }
        
    },
    extraReducers: {
        [GetCargoCompanies.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetCargoCompanies.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetCargoCompanies.fulfilled]: (state, action) => {
            state.cargoCompanies = action.payload;
            state.loading = 'Finished';
        },
        [GetWorkOrderCargo.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetWorkOrderCargo.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetWorkOrderCargo.fulfilled]: (state, action) => {
            state.workOrderCargo = action.payload;
            state.loading = 'Finished';
        },
        [SetWorkOrderCargo.pending]: (state) => {
            state.loading = 'Loading';
        },
        [SetWorkOrderCargo.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [SetWorkOrderCargo.fulfilled]: (state, action) => {
            state.setWorkOrderCargoResponse = action.payload;
            state.loading = 'Finished';
        },
        [GetWorkOrderCargoReport.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetWorkOrderCargoReport.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [GetWorkOrderCargoReport.fulfilled]: (state, action) => {
            state.initialCargoReportData = action.payload.ResponseObject;
            state.loading = 'Finished';
        },
        [UploadCargoReport.pending]: (state) => {
            state.loading = 'Loading';
        },
        [UploadCargoReport.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [UploadCargoReport.fulfilled]: (state, action) => {
            state.cargoUploadRequest = action.payload;
            state.loading = 'Finished';
        },
    }
});

export const workOrderCargoActions = workOrderCargoSlice.actions;
export const workOrderCargoThunks = {
    GetCargoCompanies,
    GetWorkOrderCargo,
    SetWorkOrderCargo,
    GetWorkOrderCargoReport,
    UploadCargoReport
}

export default workOrderCargoSlice.reducer;
